module.exports = __webpack_public_path__ + "media/images/landing_page/2023/header_imgs-a2b78d4b82200c38d6959516dad7fcf2.jpg";